import { toRem } from "../../../../helpers/theme";

const style = () => ({
    display: "flex",
    flexDirection: "column",
    marginBottom: toRem(40),
    "&:last-of-type": {
        marginBottom: 0,
    },
});

export default style;
